import type { WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type {
  AttachmentItem,
  ProjectStorageQuota,
  StorageLimits,
} from '@/types'

export const StorageActions = {
  init: createAction<WithId>('INIT_STORAGE_SAGA'),
  setStorage: createAction<WithId>('SET_STORAGE_SAGA'),
  setAttachments: createAction<WithId>('SET_ATTACHMENTS_SAGA'),
  removeAttachments: createAction<AttachmentItem[]>('REMOVE_ATTACHMENTS_SAGA'),
  appendAttachments: createAction<AttachmentItem[]>('APPEND_ATTACHMENTS_SAGA'),
}

export const InternalStorageActions = {
  setQuota: createAction<ProjectStorageQuota | null>('SET_STORAGE_QUOTA'),
  setStorage: createAction<StorageLimits>('SET_STORAGE'),
  setAttachments: createAction<AttachmentItem[]>('SET_ATTACHMENTS'),
  removeAttachments: createAction<AttachmentItem[]>('REMOVE_ATTACHMENTS'),
  appendAttachments: createAction<AttachmentItem[]>('APPEND_ATTACHMENTS'),
}
